import React from 'react';

import StatusBadge from 'shared/ui/Status/StatusBadge';

import {PaymentStatus} from '../../model/PaymentStatus';
import {colorPaymentStatus, translatePaymentStatus} from '../../lib/paymentStatus';

interface IPaymentStatusBadgeProps {
    status: PaymentStatus,
}

const PaymentStatusBadge: React.FC<IPaymentStatusBadgeProps> = ({status}) => (
    <StatusBadge color={colorPaymentStatus(status)} label={translatePaymentStatus(status)}/>
);

export default PaymentStatusBadge;
